import React from 'react'
import { user } from 'ampersand-app'
import request from '@/modules/base/util/request'
import config from '@/config'
import { toast } from '@/modules/base/components/toast/toastConfig'
import lang from '@/lang'
import { errorCodes } from '@/modules/base/util/constants'
import PasswordPromptModal from '@/modules/base/components/modal/password-prompt-modal/password-prompt-modal'
import MissingStaffDataModal from '../staff/missing-staffData-modal/missing-staffData-modal'
import { navigate } from '@/modules/layout/util/useInterceptedNavigate'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

class StaffService {
  async openStaffPage(): Promise<void> {
    try {
      if (user.sessionFromDesktop) {
        renderElement(() => (
          <PasswordPromptModal
            onSubmit={async(password) => {
              await this.openPage(password)
              close()
            }}
            onAbort={() => close()} />
        ))
        return
      }

      await this.openPage()
    } catch (error) {
      navigate('/dashboard')
      throw error
    }
  }

  async openPage(password?: string): Promise<void> {
    try {
      const response = await request(config.resourceHost + 'staff/redirect', { auth: true, method: 'POST', isConcurrent: true, data: { password } })
      const { body: { data: { redirectUrl } } } = response
      window.open(redirectUrl, '_blank')
      navigate('/dashboard')
    } catch (error) {
      if (error.statusCode === 403) {
        toast.showToast({ type: 'error', message: lang.staff.errors.forbidden })
      } else if (error?.body?.meta?.companyName?.[0]?.code === errorCodes.EXISTS) {
        toast.showToast({ type: 'error', message: lang.staff.errors.companyExists })
      } else if ((error?.body?.meta?.companyName?.[0]?.code === errorCodes.REQUIRED)) {
        renderElement((close) => (
          <MissingStaffDataModal
            open={true}
            onClose={() => close()}
          />
        ))
      } else if ((error?.body?.meta?.password?.[0]?.code === errorCodes.INCORRECT)) {
        toast.showToast({ type: 'error', message: lang.staff.errors.passwordIncorrect })
      } else {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      }
      throw error
    }
  }
}

export default new StaffService()
